/* eslint-disable max-len */
import type { FC } from 'react';

import type { IconProps } from './BaseIcon';
import { BaseIcon } from './BaseIcon';

export const ThumbsDownIcon: FC<IconProps> = ({ ...props }) => {
  return (
    <BaseIcon {...props}>
      <path d="M17.232 28a2 2 0 0 0 1.932-1.485l1.664-6.238a1 1 0 0 1 .259-.45l2.034-2.034a1 1 0 0 1 .707-.293H26a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H10.827a5 5 0 0 0-4.916 4.09l-1.457 7.864a3 3 0 0 0 2.95 3.546H13V25a3 3 0 0 0 3 3h1.232Zm0-2H16a1 1 0 0 1-1-1v-5.5a2 2 0 0 0-2-2H7.404a1 1 0 0 1-.983-1.182l1.456-7.864A3 3 0 0 1 10.827 6H22v10.122c-.103.078-.2.164-.293.257l-2.034 2.034a3 3 0 0 0-.778 1.348L17.232 26ZM24 15.5V6h2v9.5h-2Z" />
    </BaseIcon>
  );
};
